// extracted by mini-css-extract-plugin
export default {"selected-row":"ResourceTableCard_selected-row__tblC-"};